"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientEmrParser = void 0;
exports.getParser = getParser;
const helper_1 = require("./helper");
const parser_1 = require("./parser");
const EmrConstants_1 = require("./EmrConstants");
const Axxess_1 = require("./parser/axxess/Axxess");
const Netsmart_1 = require("./parser/netsmart/Netsmart");
const AloraPlus_1 = require("./parser/aloraPlus/AloraPlus");
const CarePortal_1 = require("./parser/carePortal/CarePortal");
const DataSoftLogic_1 = require("./parser/dataSoftLogic/DataSoftLogic");
const HomeHealthMd_1 = require("./parser/homeHealthMd/HomeHealthMd");
const HospiceMd_1 = require("./parser/hospiceMd/HospiceMd");
const Kantime_1 = require("./parser/kantime/Kantime");
const KinnserHospice_1 = require("./parser/kinnserHospice/KinnserHospice");
const Noteefied_1 = require("./parser/noteefied/Noteefied");
const SyngergyEMR_1 = require("./parser/synergyEmr/SyngergyEMR");
const AxxessHospice_1 = require("./parser/axxessHospice/AxxessHospice");
const KinnserTherapy_1 = require("./parser/kinnserTherapy/KinnserTherapy");
const AxxessHomeCare_1 = require("./parser/axxessHomeCare/AxxessHomeCare");
const Allegheny_1 = require("./parser/allegheny/Allegheny");
const DeveroMareIsland_1 = require("./parser/deveroMareIsland/DeveroMareIsland");
const MyIgea_1 = require("./parser/myigea/MyIgea");
const DataSoftLogicHospice_1 = require("./parser/dataSoftLogicHospice/DataSoftLogicHospice");
const EClinicalWorks_1 = require("./parser/eClinicalWorks/EClinicalWorks");
const HomecareHomebase_1 = require("./parser/homecareHomebase/HomecareHomebase");
const KantimeHomecare_1 = require("./parser/kantimeHomecare/KantimeHomecare");
const KantimeHospice_1 = require("./parser/kantimeHospice/KantimeHospice");
const OnDemandHomecare_1 = require("./parser/onDemandHomecare/OnDemandHomecare");
const Veertualtech_1 = require("./parser/veertualtech/Veertualtech");
const NetsmartInfinity_1 = require("./parser/netsmart-infinity/NetsmartInfinity");
const HospiceTools_1 = require("./parser/hospiceTools/HospiceTools");
const MatrixCare_1 = require("./parser/matrixcare/MatrixCare");
const parsers = {
    [EmrConstants_1.EmrType.KINNSER]: parser_1.Kinnser,
    [EmrConstants_1.EmrType.KINNSER_HOSPICE]: KinnserHospice_1.KinnserHospice,
    [EmrConstants_1.EmrType.KINNSER_THERAPY]: KinnserTherapy_1.KinnserTherapy,
    [EmrConstants_1.EmrType.NDOC]: parser_1.NDocs,
    [EmrConstants_1.EmrType.AXXESS]: Axxess_1.Axxess,
    [EmrConstants_1.EmrType.AXXESS_HOME_CARE]: AxxessHomeCare_1.AxxessHomeCare,
    [EmrConstants_1.EmrType.AXXESS_HOSPICE]: AxxessHospice_1.AxxessHospice,
    [EmrConstants_1.EmrType.DEVERO]: Netsmart_1.Netsmart,
    [EmrConstants_1.EmrType.ALORA_PLUS]: AloraPlus_1.AloraPlus,
    [EmrConstants_1.EmrType.CARE_PORTAL]: CarePortal_1.CarePortal,
    [EmrConstants_1.EmrType.DATA_SOFT_LOGIC]: DataSoftLogic_1.DataSoftLogic,
    [EmrConstants_1.EmrType.HOME_HEALTH_MD]: HomeHealthMd_1.HomeHealthMd,
    [EmrConstants_1.EmrType.HOSPICE_MD]: HospiceMd_1.HospiceMd,
    [EmrConstants_1.EmrType.KANTIME]: Kantime_1.Kantime,
    [EmrConstants_1.EmrType.NOTEEFIED]: Noteefied_1.Noteefied,
    [EmrConstants_1.EmrType.SYNERGY_EMR]: SyngergyEMR_1.SyngergyEMR,
    [EmrConstants_1.EmrType.ALLEGHENY]: Allegheny_1.Allegheny,
    [EmrConstants_1.EmrType.MY_IGEA]: MyIgea_1.MyIgea,
    [EmrConstants_1.EmrType.DEVERO_MIHH]: DeveroMareIsland_1.DeveroMareIsland,
    [EmrConstants_1.EmrType.CAREFICIENT]: undefined,
    [EmrConstants_1.EmrType.DATA_SOFT_LOGIC_HOSPICE]: DataSoftLogicHospice_1.DataSoftLogicHospiceParser,
    [EmrConstants_1.EmrType.E_CLINICAL_WORKS]: EClinicalWorks_1.EclinicalWorks,
    [EmrConstants_1.EmrType.HOMECARE_HOMEBASE]: HomecareHomebase_1.HomecareHomebase,
    [EmrConstants_1.EmrType.KANTIME_HOMECARE]: KantimeHomecare_1.KantimeHomecare,
    [EmrConstants_1.EmrType.KANTIME_HOSPICE]: KantimeHospice_1.KantimeHospice,
    [EmrConstants_1.EmrType.ON_DEMAND_HOMECARE]: OnDemandHomecare_1.OnDemandHomecare,
    [EmrConstants_1.EmrType.VEERTUALTECH]: Veertualtech_1.Veertualtech,
    [EmrConstants_1.EmrType.DEVERO_INFINITY]: NetsmartInfinity_1.NetsmartInfinity,
    [EmrConstants_1.EmrType.HOSPICE_TOOLS]: HospiceTools_1.HospiceTools,
    [EmrConstants_1.EmrType.MATRIX_CARE]: MatrixCare_1.MatrixCare
};
function getParser(parserType) {
    const parser = parsers[parserType];
    if (!parser) {
        throw new Error(`Parser not found for type: ${parserType}`);
    }
    return new parser();
}
class PatientEmrParser {
    constructor() {
        this.pastedData = {};
        this.pasteTargetElement = null;
        this.dataPastedElement = {
            screenInfo: {
                screen: "BODY", // Default
                screenWidth: 0,
                placeholder: "",
                className: "",
                elementId: "",
                fullElement: null,
            },
            isDataParsed: 1,
        };
        this.handlePasteBound = this.handlePaste.bind(this);
    }
    register(parserType, callback) {
        this.unRegister();
        this.callback = callback;
        this.parserType = parserType;
        document.addEventListener("paste", this.handlePasteBound);
    }
    unRegister() {
        document.removeEventListener("paste", this.handlePasteBound);
    }
    callbackEmit(data) {
        /**Note: if Name not found then isDataParsed value 0*/
        if (!data.parseData ||
            !data.parseData.patientInfo ||
            !data.parseData.patientInfo.firstName) {
            this.dataPastedElement.isDataParsed = 0;
        }
        // Return callback
        this.callback(Object.assign(Object.assign(Object.assign({}, this.dataPastedElement), data), { pastedData: this.pastedData, pasteTargetElement: this.pasteTargetElement, parserType: this.parserType }));
    }
    handlePaste(e) {
        this.dataPastedElement.isDataParsed = 1;
        let clipboardData, pastedData;
        // **Get pasted data via clipboard API.*/
        // @ts-ignore
        clipboardData = e.clipboardData || window.clipboardData;
        pastedData = clipboardData.getData("Text");
        // *Invalid data.*/
        if ((0, helper_1.arrayLength)(pastedData) < 500 &&
            pastedData.split("").filter((x) => x === "\n").length < 10) {
            return;
        }
        // **For Identify this is parser data */
        e.preventDefault();
        e.stopPropagation();
        // **Save PastedData for logging */
        this.pastedData = pastedData;
        this.pasteTargetElement = e.target;
        this.getMoreUserInfo(e);
        getParser(this.parserType).parse(pastedData, e, this.callbackEmit.bind(this));
    }
    /**
     * @function getMoreUserInfo
     * @param e
     * @summary Getting More information from pasted data by user.
     */
    getMoreUserInfo(e) {
        const { target } = e;
        this.dataPastedElement.screenInfo.screen = target.nodeName;
        this.dataPastedElement.screenInfo.className = target.className;
        this.dataPastedElement.screenInfo.screenWidth = target.clientWidth;
        this.dataPastedElement.screenInfo.placeholder = target.placeholder;
        this.dataPastedElement.screenInfo.elementId = target.id;
        // If body not
        if (target.nodeName != "BODY") {
            this.dataPastedElement.screenInfo.fullElement = target.innerHTML;
        }
    }
}
exports.PatientEmrParser = PatientEmrParser;
